import { accompagnements } from './_accompagnement';
accompagnements();

import { dossierDeleteLink } from './_dossier_delete_link.js';
dossierDeleteLink();

import { boutonFacturation } from './_bouton_facturation.js';
boutonFacturation();
